import { createContext } from "react";

export type ContextValue = {
    userInfo: any;
    setContextValue: (newData: any) => void;
  };
  
export const defaultContextValue: ContextValue = {
    userInfo: null,
    setContextValue: () => {},
};
export const DataContext = createContext(defaultContextValue);